import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getCommission = createAsyncThunk(
  "commission/getCommission",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/commissions?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createCommission = createAsyncThunk(
  "commission/createCommission",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/commissions`, args);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateCommission = createAsyncThunk(
  "commission/updateCommission",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/commissions/${args._id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteCommission = createAsyncThunk(
  "commission/deleteCommission",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(`/commissions/${args._id}`);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const commissionSlice = createSlice({
  name: "commission",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCommission.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCommission.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data;
        state.itemsCount = payload.data?.length;
        state.pages = 1;
        state.error = null;
      })
      .addCase(getCommission.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createCommission.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createCommission.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload?.data) {
          state.data.push(payload.data); // only push when it’s real
          state.itemsCount = state.data.length; // keep count in sync
        }
        state.error = null;
      })
      .addCase(createCommission.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateCommission.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateCommission.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // const indexAt = state.data?.findIndex(el => el._id === payload.data._id);
        // state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateCommission.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteCommission.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteCommission.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter((el) => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteCommission.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      });
  },
});

export default commissionSlice.reducer;
